import { useTranslation } from 'react-i18next';

import { Button, ImageSlider } from '../../../UI';
import LimitedNav from '../../../Nav/Limited-nav/Limited-nav';

import { WidgetPreviewProps } from './types';

const WidgetPreview = ({
  isInstallButtonLoading,
  widgetData,
  onInstallClick,
  customPaddings,
  isInstalled,
  isAvailable,
  onBackClick,
  onCloseClick,
  onForwardClick,
  className,
}: WidgetPreviewProps) => {
  const { t } = useTranslation();

  const handleCloseButtonClick = () => {
    if (onCloseClick) {
      onCloseClick();
    }
  };

  const handleBackButtonClick = () => {
    if (onBackClick) {
      onBackClick();
    }
  };

  const handleForwardClick = () => {
    if (onForwardClick) {
      onForwardClick();
    }
  };

  const handleInstallClick = () => {
    if (onInstallClick) {
      onInstallClick(widgetData.suggestedSize);
    }
  };

  return (
    <>
      <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen z-70">
        <LimitedNav
          className="fixed top-0 left-0 z-80"
          showCloseButton
          onCloseButtonClick={handleCloseButtonClick}
        />
        <div
          className={`relative flex flex-col items-center justify-center rounded-xl min-w-700 max-w-700 bg-white overflow-hidden dark:bg-grey-80 ${
            customPaddings ? customPaddings : 'p-14'
          } ${className || ''}`}
        >
          <div className="flex flex-shrink-0 items-center justify-between w-full h-28 dark:bg-grey-90 dark:border-grey-80">
            <div
              className="flex flex-shrink-0 items-center justify-center w-20 border-r border-grey-10 h-full mr-5 cursor-pointer dark:border-grey-80"
              onClick={handleBackButtonClick}
            >
              <span className="material-icons select-none">west</span>
            </div>
            <div className="flex w-full">
              <img
                className="flex w-16 h-16 rounded-xl overflow-hidden mr-4"
                src={widgetData.icon.size?.original}
                alt=""
              />
              <div className="flex flex-col">
                <span className="text-sm font-semibold uppercase">
                  {widgetData.name}
                </span>
                <span className="text-xs font-normal">
                  {widgetData.category}
                </span>
                {isInstalled && isAvailable && (
                  <div className="flex items-center justify-center rounded-md bg-black w-18 h-5">
                    <span className="text-xs text-primary font-normal">
                      {t('widget.add.alreadyInstalled')}
                    </span>
                  </div>
                )}
              </div>
            </div>
            {!isInstalled && isAvailable && (
              <Button
                variant="secondary"
                type="button"
                onClick={handleInstallClick}
                loading={isInstallButtonLoading}
              >
                {t('widget.add.install')}
              </Button>
            )}
            <div
              className="flex flex-shrink-0 items-center justify-center w-20 border-l border-grey-10 h-full ml-5 cursor-pointer dark:border-grey-80"
              onClick={handleForwardClick}
            >
              <span className="material-icons  select-none">east</span>
            </div>
          </div>
          <div className="flex flex-col w-full bg-grey-5 px-3 py-5 overflow-auto dark:bg-grey-70 min-h-80">
            <div className={'mb-4'}>
              <ImageSlider images={widgetData.images.items} />
            </div>

            <div className="flex flex-col w-full px-10 mb-4">
              <span className="text-sm text-black mt-2 mb-4">
                {t('widget.add.details')}
              </span>
              <p className="text-sm text-grey-50">{widgetData.description}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed top-0 left-0 w-screen h-screen z-60 bg-black-backdrop" />
    </>
  );
};

export default WidgetPreview;
